export function getRandomDefaultCover(): Promise<File> {
  const randomIndex = Math.floor(Math.random() * 4) + 1;

  return fetch(`/images/newProjectDefault/${randomIndex}.png`)
    .then((response) => response.blob())
    .then((content) => new File([content], 'cover.png'));
}
